"use client"

import {Select, SelectContent, SelectItem, SelectTrigger, SelectValue} from "@/components/ui/select";
import {Headline} from "@/components/ui/headline";
import {useRouter} from "next/navigation";
import ProtectedComponent from "@/components/custom/ProtectedComponent";
import {useSystemSettings} from "@/hooks/useSystemSettings";
import {useFlags} from "@/contexts/FlagsContext";

interface TopbarSettingsInterface {
    unitSystemSwitchTranslation: {
        heading: string;
        metric: string;
        imperial: string;
        notification: string;
    },
    scopeSystemSwitchTranslation: {
        heading: string;
        internal: string;
        external: string;
    },
    language: string,
    region: string
}

export function TopbarSettings({ unitSystemSwitchTranslation, scopeSystemSwitchTranslation, language, region }: TopbarSettingsInterface) {
    const {unitSystem, scopeSystem} = useSystemSettings();

    const router = useRouter();

    const flags = useFlags();

    function handleUnitSystemChange(value: string) {
        document.cookie = `unitSystem=${value}; path=/; max-age=31536000`;

        const searchParams = new URLSearchParams(window.location.search);
        searchParams.set("unitSystem", value);

        router.replace(`?${searchParams.toString()}`);
    }

    function handleScopeSystemChange(value: string) {
        document.cookie = `scopeSystem=${value}; path=/; max-age=31536000`;

        const searchParams = new URLSearchParams(window.location.search);
        searchParams.set("scopeSystem", value);

        router.replace(`?${searchParams.toString()}`);
    }

    return (
        <div className={"flex md:flex-col gap-2"}>
            <div>
                <Headline variant="h2" size="md" className="font-normal">{unitSystemSwitchTranslation.heading}</Headline>
                <Select defaultValue={unitSystem!} onValueChange={handleUnitSystemChange}>
                    <SelectTrigger className="w-[180px]">
                        <SelectValue placeholder="Theme"/>
                    </SelectTrigger>
                    <SelectContent>
                        <SelectItem value="metric">{unitSystemSwitchTranslation.metric}</SelectItem>
                        <SelectItem value="imperial">{unitSystemSwitchTranslation.imperial}</SelectItem>
                    </SelectContent>
                </Select>
            </div>
            {flags.scopeSystem && (
                <div>
                    <Headline variant="h2" size="md" className="font-normal">{scopeSystemSwitchTranslation.heading}</Headline>
                    <Select defaultValue={scopeSystem!} onValueChange={handleScopeSystemChange}>
                        <SelectTrigger className="w-[180px]">
                            <SelectValue placeholder="Theme"/>
                        </SelectTrigger>
                        <SelectContent>
                            <SelectItem value="internal">{scopeSystemSwitchTranslation.internal}</SelectItem>
                            <SelectItem value="external">{scopeSystemSwitchTranslation.external}</SelectItem>
                        </SelectContent>
                    </Select>
                </div>
            )}
        </div>
    )
}